import Immutable from 'immutable';
import { isEmpty } from './validation';

let numberFormatter;
let decimalSeparator;
let groupSeparator;
let integerNumberRegexp;
let grouplessNumberRegexp;
let _localeName;

function createNumberFormatter(minimumFractionDigits, maximumFractionDigits) {
	if (typeof minimumFractionDigits === 'number') {
		return Intl.NumberFormat(_localeName, {
			minimumFractionDigits,
			maximumFractionDigits
		});
	} else {
		return Intl.NumberFormat(_localeName, {
			maximumSignificantDigits: 20
		});
	}
}

export function setNumberFormatLocale(localeName) {
	_localeName = localeName || 'cs';
	numberFormatter = createNumberFormatter();
	let parts = numberFormatter.formatToParts(123456.34);
	decimalSeparator = parts.find(p => p.type === 'decimal').value;
	groupSeparator = parts.find(p => p.type === 'group').value;
	let groupSeparators;
	if (groupSeparator !== ' ' && groupSeparator.trim() === '') {
		groupSeparators = groupSeparator + ' ';
	} else {
		groupSeparators = groupSeparator;
	}
	integerNumberRegexp = new RegExp('[^0-9' + groupSeparators + ']', 'g');
	grouplessNumberRegexp = new RegExp('[' + groupSeparators + ']', 'g');
}


export function formatNumber(value) {
	if (typeof value !== 'number') {
		return '';
	}
	return numberFormatter.format(value);
}

export function formatGrouplessNumber(value) {
	let res = formatNumber(value);
	if (typeof res === 'string') {
		res = res.replace(grouplessNumberRegexp, '')
	}
	return res;
}

export function getFixedDecimalFormatNumber(decimalDigits) {
	const numberFormatter = createNumberFormatter(decimalDigits, decimalDigits);
	return function(value) {
		if (typeof value !== 'number') {
			return '';
		}
		return numberFormatter.format(value);
	};
}

function integerNumberInputFilter(value) {
	if (typeof value === 'string') {
		let pfx = '';
		if (value.startsWith('-')) {
			pfx = '-';
			value = value.substring(1);
		}
		return pfx + value.replace(integerNumberRegexp, '');
	}
}

export function getNumberInputFilter(maxDecimals) {
	maxDecimals = maxDecimals || 0;
	if (maxDecimals === 0) {
		return integerNumberInputFilter;
	} else {
		return function(value) {
			let pfx = '';
			if (value.startsWith('-')) {
				pfx = '-';
				value = value.substring(1);
			}
			let tokens = value.split(decimalSeparator);
			if (tokens.length === 1) {
				return pfx + value.replace(integerNumberRegexp, '');
			} else {
				return pfx + tokens[0].replace(integerNumberRegexp, '') + decimalSeparator + (tokens[1].replace(/[^0-9]/g, '').substring(0, maxDecimals));
			}
		}
	}
}

export function parseNumber(value) {
	if (typeof value === 'string') {
		value = value.replace(/\s/g, '');
		if (!value) {
			return null;
		}
		value = value.replace(groupSeparator, '');
		if (decimalSeparator !== '.') {
			value = value.replace(decimalSeparator, '.');
		}
		return Number(value);
	} else if (typeof value === 'number') {
		return value;
	}
	return null;
}

export const EMPTY_NUMBER_RANGE = Immutable.Map({
	type: 'numberRange',
	valid: true,
	from: null,
	to: null,
	text: ''
});

export function createNumberRange(from, to, grouplessFormat) {
	let text;
	let format = grouplessFormat ? formatGrouplessNumber : formatNumber;
	if (typeof from === 'number') {
		if (typeof to === 'number') {
			text = format(from) + ' - ' + format(to);
		} else {
			text = format(from) + ' - ';
		}
	} else {
		if (typeof to === 'number') {
			text = ' - ' + format(to);
		}
	}
	if (!text) {
		return EMPTY_NUMBER_RANGE;
	}
	return EMPTY_NUMBER_RANGE
		.set('from', from)
		.set('to', to)
		.set('text', text);
}

export function parseSearchNumber(value) {
	if (typeof value !== 'string') {
		return EMPTY_NUMBER_RANGE;
	}
	value = value.trim();
	if (!value) {
		return EMPTY_NUMBER_RANGE;
	}
	const tokens = value.split('-');
	let from, to;
	if (tokens.length === 1) {
		if (tokens[0]) {
			from = parseNumber(tokens[0]);
			to = parseNumber(tokens[0]);
		} else {
			from = null;
			to = null;
		}
	} else {
		if (tokens[0]) {
			from = parseNumber(tokens[0]);
		} else {
			from = null;
		}
		if (tokens[1]) {
			to = parseNumber(tokens[1]);
		} else {
			to = null;
		}
	}
	let valid = true;
	if (isNaN(from)) {
		from = null;
		valid = false;
	}
	if (isNaN(to)) {
		to = null;
		valid = false;
	}
	const res = Immutable.Map({
		type: 'numberRange',
		valid,
		from,
		to,
		text: value
	});

	return res;
}


export function round2(value) {
	return Math.round(value * 100) / 100;
}

export function round4(value) {
	return Math.round(value * 10000) / 10000;
}

setNumberFormatLocale('cs');
